import TabletOverlay from "./tablet-overlay.component";

export default TabletOverlay;
